import { api } from './api'

export const fetchPermissions = (query) => api.get('/permission', query)
